import inventory from '@/locales/en/inventory/inventory.locales';

export default {
    ...inventory,
};
